import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { WebsiteForm } from './WebsiteForm'
import { CmsProvider } from '../cms/CmsContext'
import ErrorBoundary from '../errorBoundary'
import GlobalStyles from '../../../styles/globalIndependent'
import { GoogleReCaptchaProvider } from '../recaptcha'
import settings from '../settings'
import { PortalProvider } from '../portal'

const queryCache = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
})

const config = window.BADA_DATA || {}

export const WebsiteFormApp = ({ serviceId, serviceCode, storeId }) => (
  <QueryClientProvider client={queryCache}>
    <GoogleReCaptchaProvider reCaptchaKey={settings.recaptcha?.key}>
      <GlobalStyles />
      <CmsProvider>
        <PortalProvider>
          <ErrorBoundary>
            <WebsiteForm
              storeId={storeId}
              serviceCode={serviceCode || config.serviceCode}
              serviceId={serviceId || config.serviceId}
            />
          </ErrorBoundary>
        </PortalProvider>
      </CmsProvider>
    </GoogleReCaptchaProvider>
  </QueryClientProvider>
)
